import loginBackground from 'assets/images/plutoIntroImage_lowres.png';
import { PageBackground, PageContainer } from 'pages/Intro/Intro.styled';
import { IntroHeader } from 'pages/Intro/IntroHeader/IntroHeader';
import { IntroPageContent } from 'pages/Intro/IntroPageContent/IntroPageContent';

export const IntroDesktop = () => {
  return (
    <PageContainer>
      <PageBackground
        style={{
          backgroundImage: `url(${loginBackground})`,
        }}
      >
        <IntroHeader isMobile={false} />
      </PageBackground>
      <IntroPageContent isMobile={false} />
    </PageContainer>
  );
};
